import { ShopWishlist } from './wishlist.js';

export class ShopWishlistGrid extends HTMLElement {
  wishlist = new ShopWishlist();
  grid = document.querySelector('[data-grid]');
  emptyState = document.querySelector('[data-empty-state]');

  async connectedCallback() {
    if (window.location.hash.includes('#wishlist-')) {
      await this.fetchWishlistFromUrl();
    } else {
      await this.fetchWishlist();
    }

    // Listen for wishlist changes only on wishlist page
    this.boundWishlistChangeHandler = this.handleWishlistChange.bind(this);
    document.addEventListener('wishlist:changed', this.boundWishlistChangeHandler);

    document.querySelector('[data-wishlist-share]')?.addEventListener('click', async () => {
      const list = await this.wishlist.getList();
      const encoded = encodeURIComponent(list.join(';'));
      if (window.location.hash.includes('#wishlist-')) {
        try {
          await navigator.share({
            text: 'Wunschliste',
            url: `${window.location.href}`,
            title: 'Wunschliste',
          });
        } catch (e) {
          await navigator.clipboard.writeText(`${window.location.href}`);
        }
      } else {
        try {
          await navigator.share({
            text: 'Wunschliste',
            url: `${window.location.href}#wishlist-${encoded}`,
            title: 'Wunschliste',
          });
        } catch (e) {
          await navigator.clipboard.writeText(`${window.location.href}#wishlist-${encoded}`);
        }
      }
    });
  }

  disconnectedCallback() {
    // Clean up event listener when component is removed
    if (this.boundWishlistChangeHandler) {
      document.removeEventListener('wishlist:changed', this.boundWishlistChangeHandler);
    }
  }

  async handleWishlistChange() {
    // Re-fetch and render the wishlist when it changes
    await this.fetchWishlist();
  }

  async fetchWishlist() {
    const list = await this.wishlist.getList();

    if (list == undefined || list === null || list.length === 0) {
      this.grid.style.display = 'none';
      this.emptyState.style.display = 'block';
      return;
    }
    this.grid.style.display = '';
    this.emptyState.style.display = 'none';

    const encoded = encodeURIComponent(list.join(';'));
    const url = `/search?view=wishlist&q=${encoded}`;
    const response = await fetch(url);
    const html = await response.text();
    this.grid.innerHTML = html;
  }

  async fetchWishlistFromUrl() {
    const hash = window.location.hash.replace('#wishlist-', '');
    const url = `/search?view=wishlist&q=${hash}`;
    const decoded = decodeURIComponent(hash);
    const list = decoded.split(';');
    this.wishlist.setList(list);
    const response = await fetch(url);
    const html = await response.text();
    this.grid.innerHTML = html;
  }
}
if (!customElements.get('shop-wishlist-grid')) {
  customElements.define('shop-wishlist-grid', ShopWishlistGrid);
}
